import { Question } from '@empathy/survey-core';

export class QuestionEditor extends Question {
  active: boolean;
}
